import { render } from "./OrderHistory.vue?vue&type=template&id=cf1af830&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"

import "./OrderHistory.vue?vue&type=style&index=0&id=cf1af830&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1af830"]])

export default __exports__